import { useEffect, useState } from 'react';
import { apiClient } from '../api/client';
import { Catalog } from '../utils/catalog';

// O catálogo é igual para todos os usuários e só muda com deploy: busca uma vez
// por sessão do painel e guarda em memória. Falha não é guardada (tenta de novo ao reabrir).
let catalogEmCache: Catalog | null = null;
let buscaEmAndamento: Promise<Catalog> | null = null;

function carregarCatalogo(): Promise<Catalog> {
  if (catalogEmCache) return Promise.resolve(catalogEmCache);
  if (!buscaEmAndamento) {
    buscaEmAndamento = apiClient
      .get<Catalog>('/catalog')
      .then((catalogo) => {
        catalogEmCache = catalogo;
        return catalogo;
      })
      .finally(() => {
        buscaEmAndamento = null;
      });
  }
  return buscaEmAndamento;
}

export function useCatalog() {
  const [catalog, setCatalog] = useState<Catalog | null>(catalogEmCache);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (catalogEmCache) {
      setCatalog(catalogEmCache);
      return;
    }
    let ativo = true;
    carregarCatalogo()
      .then((catalogo) => {
        if (ativo) setCatalog(catalogo);
      })
      .catch((err: Error) => {
        if (ativo) setError(err);
      });
    return () => {
      ativo = false;
    };
  }, []);

  return { catalog, isLoading: !catalog && !error, error };
}
